module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-note-list row column"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Priority"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.priority),
      expression: "search.priority"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "priority", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All priorities")]), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Minor")]), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Medium")]), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Major")])])])]), (_vm.filters && !_vm.filters.hasOwnProperty('vehicle_id')) ? _c('div', {
    staticClass: "column"
  }, [_c('selectize-vehicle', {
    attrs: {
      "value-field": "id"
    },
    model: {
      value: (_vm.search.vehicle_id),
      callback: function($$v) {
        _vm.$set(_vm.search, "vehicle_id", $$v)
      },
      expression: "search.vehicle_id"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Type"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.type),
      expression: "search.type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All types")]), _c('option', {
    attrs: {
      "value": "CLEANING"
    }
  }, [_vm._v("Cleaning")]), _c('option', {
    attrs: {
      "value": "ROUTINE"
    }
  }, [_vm._v("Routine")]), _c('option', {
    attrs: {
      "value": "PREPARATION"
    }
  }, [_vm._v("Preparation")]), _c('option', {
    attrs: {
      "value": "CHECK_OUT"
    }
  }, [_vm._v("Check-out")]), _c('option', {
    attrs: {
      "value": "REPOSITIONING"
    }
  }, [_vm._v("Repositioning")]), _c('option', {
    attrs: {
      "value": "ACCIDENT"
    }
  }, [_vm._v("Accident")]), _c('option', {
    attrs: {
      "value": "EXTERIOR_REPAIR"
    }
  }, [_vm._v("Exterior repair")]), _c('option', {
    attrs: {
      "value": "RECHARGE"
    }
  }, [_vm._v("Recharge")]), _c('option', {
    attrs: {
      "value": "LOW_BATTERY"
    }
  }, [_vm._v("Low Battery")])])])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Status"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search.status),
      expression: "search.status"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.search, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All statuses")]), _c('option', {
    attrs: {
      "value": "NEW"
    }
  }, [_vm._v("New")]), _c('option', {
    attrs: {
      "value": "ASSIGNED"
    }
  }, [_vm._v("Assigned")]), _c('option', {
    attrs: {
      "value": "IN_PROGRESS"
    }
  }, [_vm._v("In progress")]), _c('option', {
    attrs: {
      "value": "COMPLETED"
    }
  }, [_vm._v("Completed")]), _c('option', {
    attrs: {
      "value": "REFUSED"
    }
  }, [_vm._v("Refused")])])])])]), _c('base-list', {
    ref: "baseList",
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "component-type": _vm.listingType,
      "search": _vm.search
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2607c007!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/MaintenanceRequestList.vue
// module id = 2348
// module chunks = 1